<template>
  <AppDialog
    :visible="props.visible"
    @close="handleClose"
    :title="props.title"
    :confirmText="props.buttonText"
    @confirm="handleConfirm"
    @show="handleVisible"
    :headerImage="props.headerImage"
  >
    <template
      #header-image
      v-if="props.type === 'WANT_IT_NEXT' && props.imageList && props.imageList.length > 2"
    >
      <div class="active-image-container">
        <img
          v-for="imageItem in props.imageList.slice(0, 3)"
          :src="imageItem"
          class="award-image"
          :key="imageItem"
        />
      </div>
    </template>
    <template #content>
      <div class="active-dialog-content">
        <template v-for="(text, index) in props.title.split(/{([^}]*)}/)" :key="index">
          <span v-if="index % 2 === 0">{{ text }}</span>
          <img v-else-if="text === 'want_icon'" :src="wantIcon" class="want-icon" />
        </template>
      </div>
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import AppDialog from '@zaohaowu/website-components/components/Dialog/index.vue'
  import wantIcon from '@/assets/images/icon_want.svg'
  import trackEvent from '@/track/trackEvent'
  import { useNavigate } from '@zaohaowu/website-common/hooks/useNavigate'
  import { eventBus } from '@zaohaowu/website-common/utils/eventBus'
  defineOptions({ name: 'ActivityDialog' })
  const { navigateToIncentive } = useNavigate()
  const emit = defineEmits(['close'])
  type IActivityDialogProps = {
    visible: boolean
    type: 'ACTIVE' | 'WANT_IT_NEXT'
    imageList?: string[]
    buttonText: string
    title: string
    headerImage?: string
  }
  const popupType = computed(() => {
    return props.type === 'WANT_IT_NEXT' ? 'new_user_popup' : 'login_task_popup'
  })
  const props = defineProps<IActivityDialogProps>()
  const handleClose = () => {
    eventBus.trigger('refreshBriefInfo')
    emit('close')
  }
  const handleConfirm = () => {
    navigateToIncentive({
      enterFrom: popupType.value,
      pageName: 'task'
    })
    emit('close')
  }
  const handleVisible = () => {
    trackEvent.track('want_popup_show', {
      popup_type: popupType.value
    })
  }
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
